import React, { useContext, useState, useEffect } from "react";
import ModalComponent from "../../Components/ModalComponent";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { Link, useParams } from "react-router-dom";
import ListPaymemtsUsers from "../../Components/listPaymentsUser";
import Repo from "../../Utility/Repo";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import Pagination from "../../Components/Pagination";
import LabelsLoader from "../../Utility/labelsLoader";
import AllegatiComponent from "../../Components/AllegatiComponent";
import UploadFile from "../../Components/UploadFile";
import SubscriptionDetailADI from "./SubscriptionDetailADI";
import SubscriptionDetailSAD from "./SubscriptionDetailSAD";
import SubscriptionDetailCentroFamiglia from "./SubscriptionDetailCentroFamiglia";
import SubscriptionDetailRelation from "./SubscriptionDetailRelation";
import SubscriptionDetailFamiglieAffidatarie from "./SubscriptionDetailFamiglieAffidatarie";
import SubscriptionDetailGenerico from "./SubscriptionDetailGenerico";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { Input, Row, Col } from "design-react-kit";
import EditorJs from "../../Components/Editor";
import { useCookies } from "react-cookie";
import jwt_decode from "jwt-decode";
import CheckboxOption from "../../Components/CheckboxOption";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function SubscriptionDetail(props) {
  const [cookies] = useCookies();
  const todayFormatted = moment().format("DD/MM/YYYY");
  const [showFileToggle, toggleModalShowFile] = useState(false);
  const [showModalModify, setshowModalModify] = useState(false);
  let query = useQuery();
  const subscriprionParamId = query.get("id");
  const apiToken = useContext(TokenContext);
  const [loading, setLoading] = useState(true);
  const [userSubscriptions, setUserSubscriptions] = useState(null);
  const [subscriprionUpdate, setSubscriprionUpdate] = useState({
    id: subscriprionParamId,
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [error, setError] = useState("");
  const [file, setFile] = useState({
    type: "application/pdf",
    data: "",
  });
  const [dettaglio, setDettaglio] = useState();

  const [fileUpload, setFileUpload] = useState();

  const [showModalAdd, toggleModalAdd] = useState(false);
  const [showModalAddHours, toggleModalAddHours] = useState(false);
  const [showModalPunteggio, toggleModalPunteggio] = useState(false);
  const [showModalMinori, toggleModalMinori] = useState(false);
  const [fileSettings, setFileSettings] = useState({});
  const [firstTime, setFirstTime] = useState(true);
  const [totaleScore, setTotaleScore] = useState();
  const [couponsList, setCouponsList] = useState([]);
  const [paymentsTemp, setPaymentsTemp] = useState();
  const [payments, setPayments] = useState();
  const [refundTemp, setRefundTemp] = useState();
  const [refund, setRefund] = useState();
  const [isOpenCoupon, toggleModalCoupon] = useState(false);
  const [emailSend, setEmailSend] = useState("");
  const [errorMessageImport, setErrorMessageImport] = useState(false);
  const [apiError, setApiError] = useState({});

  const [fileBase64, setFileBase64] = useState();
  const [fileB64, setFileB64] = useState(false);

  const [uploadFile, setUploadFile] = useState(false);
  const [fileName, setFilename] = useState("");
  const [value, setValue] = useState();
  const [description, setDescription] = useState("");
  const [validationFile, setValidationFile] = useState(false);
  const [isOpen, toggleModal] = useState(false);
  const [data, setData] = useState();
  const [isAlertVisible, setIsAlertVisible] = useState();
  const [validation, setValidation] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [haveIsee, setHaveIsee] = useState(false);
  const number = new RegExp("^[+]?([0-9]{0,})*[,]?([0-9]{0,2})?$", "g");
  const [nucleoFamiliare, setNucleoFamiliare] = useState();
  const [editDescrizioneIstanze, setEditDescrizioneIstanze] = useState(false);
  const [descrizioneIstanzeEdit, setDescrizioneIstanzeEdit] = useState();

  const [showModalOtherServices, setShowModalOtherServices] = useState(false);
  const [minoriError, setMinoriError] = useState("");

  const bodyFile = () => {
    return (
      <object
        width="100%"
        height="900"
        data={file && file.data}
        type={file && file.type}
      ></object>
    );
  };

  const bodyOtherService = () => {
    return (
      <div className="mb-5">
        <CheckboxOption
          formData={subscriprionUpdate}
          setFormData={setSubscriprionUpdate}
          title={"Altre misure di sostegno di cui il richiedente beneficia:"}
          options={[
            "Pro.vi.",
            "Patto di Cura",
            "Sostegno Familiare",
            "Cure domiciliari erogate con Buoni Servizio",
          ]}
          col={2}
        />
      </div>
    );
  };

  const normalizeMultilineText = (value) => {
    if (value === null || value === undefined) return "";

    return String(value)
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/\\n/g, "\n");
  };

  const handleSave = () => {
    setLoading(true);
    Repo.postInsertAttoFirmato(
      apiToken,
      subscriprionParamId,
      fileUpload,
      fileSettings.fileName,
      fileSettings.description,
    )
      .then((response) => {
        window.location.reload();
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        Repo.handleApiError(error, setError);
      });
  };

  const handleCloseModalModify = () => {
    if (fileB64) {
      window.location.reload();
    }
  };

  const handleUpdate = () => {
    setLoading(true);
    let stateNumber =
      subscriprionUpdate.state == "VALIDATED"
        ? 2
        : subscriprionUpdate.state == "REFUSED"
          ? 3
          : subscriprionUpdate.state == "SUSPENDED"
            ? 4
            : 0;
    let obj = {
      id: subscriprionUpdate.id,
      announcementId: subscriprionUpdate.announcementId,
      orePreviste: subscriprionUpdate.orePreviste,
      dataInizio: subscriprionUpdate.dataInizio,
      dataFine: subscriprionUpdate.dataFine,
      descrizione: subscriprionUpdate.descrizione,
      nProtocolloUscita: subscriprionUpdate.nProtocolloUscita,
      otherServices: subscriprionUpdate.otherServices,
      trasmissioneCoop: dettaglio,
      descrizioneIstanze: subscriprionUpdate.descrizioneIstanze,
      componentiNucleoFamiliareIds:
        subscriprionUpdate.componentiNucleoFamiliareIds,
      state: stateNumber,
    };

    Repo.postSubscribeUserFromOperator(apiToken, JSON.stringify(obj))
      .then((response) => {
        if (response.data.trasmissioneCoop) {
          setFileB64(response.data.trasmissioneCoop);
        } else window.location.reload();
        setLoading(false);
      })
      .catch((error) => {
        Repo.handleApiError(error, setError);
        setLoading(false);
      });
  };

  const handleUpdateOre = () => {
    setLoading(true);
    Repo.postInsertHours(
      apiToken,
      subscriprionParamId,
      subscriprionUpdate.orePreviste,
    )
      .then((response) => {
        window.location.reload();
      })
      .catch((error) => {
        Repo.handleApiError(error, setError);
        setLoading(false);
      });
  };

  const handleUpdateRankingScore = () => {
    setLoading(true);
    Repo.postInsertScore(
      apiToken,
      subscriprionParamId,
      subscriprionUpdate.punteggioGravita,
    )
      .then((response) => {
        window.location.reload();
      })
      .catch((error) => {
        Repo.handleApiError(error, setError);
        setLoading(false);
      });
  };

  useEffect(() => {
    subscribeUser(subscriprionParamId);
  }, [subscriprionParamId]);

  useEffect(() => {
    var decoded = jwt_decode(cookies.api_token);
    const user = decoded.FullName;
    if (subscriprionUpdate?.announcement?.service?.tipoServizio === 5) {
      setDettaglio(`
  <p>Prot. </p>
  <p style="text-align:right;">${cookies.user_profile.AreaName}, ${todayFormatted}</p>
  <p style="text-align:right;">Spett.le</p>
  <p style="text-align:right;">EGLE Soc. Cooperativa Sociale</p>
  <p><b>OGGETTO: SERVIZIO CENTRO PER LA FAMIGLIA .  – ${subscriprionUpdate?.user?.lastName} ${subscriprionUpdate?.user?.firstName}. Trasmissione progetto per attivazione servizio.</b></p>
  <p>In allegato alla presente si trasmette il progetto per l’attivazione del Servizio in oggetto </p>
  <p>Le prestazioni erogate <b>non</b> andranno imputate sulle risorse afferenti al fondo povertà.</p>

<p>Cordiali saluti</p>

  <p style="text-align:right;">IL RUP</p>
  <p style="text-align:right;">Dott./Dott.ssa ${user}</p>
`);
    } else if (subscriprionUpdate?.announcement?.service?.tipoServizio === 3)
      setDettaglio(`
  <p>Prot. </p>
  <p style="text-align:right;">${cookies.user_profile.AreaName}, ${todayFormatted}</p>
  <p style="text-align:right;">Spett.le</p>
  <p style="text-align:right;">EGLE Soc. Cooperativa Sociale</p>
  <p><b>OGGETTO: SERVIZIO ASSISTENZA EDUCATIVA DOMICILIARE AI SENSI DELL'ART. 87BIS DEL R.R. N. 4/2007 E SS.MM.II.  – ${subscriprionUpdate?.user?.lastName} ${subscriprionUpdate?.user?.firstName}. Trasmissione progetto per attivazione servizio.</b></p>
  <p>In allegato alla presente si trasmette il progetto per l’attivazione del Servizio in oggetto  per n. _ ore settimanali.</p>
  <p>Le prestazioni erogate <b>non</b> andranno imputate sulle risorse afferenti al fondo povertà.</p>

<p>Cordiali saluti</p>

  <p style="text-align:right;">IL RUP</p>
  <p style="text-align:right;">Dott./Dott.ssa ${user}</p>

`);
  }, [subscriprionUpdate?.user]);

  const subscribeUser = (subscriptionId) => {
    setLoading(true);
    Repo.getSubscriptionById(apiToken, subscriptionId)
      .then((response) => {
        if (response.status === 200) {
          setUserSubscriptions(response.data);

          Repo.ComponenteNucleoFamiliare(
            apiToken,
            "F",
            "Visualizza",
            response?.data?.user?.id,
            null,
          )
            .then((response) => {
              if (response.status === 200) {
                setNucleoFamiliare(response.data);
              }
            })
            .catch((error) => {
              Repo.handleApiError(error, setError);
            });
          setSubscriprionUpdate({
            ...response.data,
            userId: response.data.user.id,
            componentiNucleoFamiliareIds: response.data
              .subscriptionComponentiNucleoFamiliare
              ? response.data.subscriptionComponentiNucleoFamiliare.map(
                  (c) => c.componenteNucleoFamiliareId,
                )
              : [],
          });
        }
      })
      .catch((error) => {
        setApiError({ isVisible: true, message: setErrorMessageImport(error) });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  //
  const sendReceipt = async () => {
    setValidation(true);
    setValidationFile(true);

    let passedValidation = true;

    if (!uploadFile) {
      passedValidation = false;
      setValidationFile(false);
    }

    if (!value?.trim()) {
      passedValidation = false;
    }

    if (passedValidation) {
      const base64Data = uploadFile.split(",")[1];
      const mimeType = uploadFile.split(";")[0].split(":")[1];
      const dataToSend = {
        base64: base64Data,
        type: mimeType,
        state: 1,
        name: fileName,
        value: value.replace(".", "").replace(",", "."),
        description: description,
        subscriptionId: subscriprionParamId,
      };

      setData(JSON.stringify(dataToSend));
      toggleModal(true);
    }
  };

  const handleCheck = (id) => {
    if (subscriprionUpdate?.componentiNucleoFamiliareIds?.includes(id)) {
      setSubscriprionUpdate({
        ...subscriprionUpdate,
        componentiNucleoFamiliareIds:
          subscriprionUpdate?.componentiNucleoFamiliareIds?.filter(
            (x) => x !== id,
          ),
      });
    } else {
      setSubscriprionUpdate({
        ...subscriprionUpdate,
        componentiNucleoFamiliareIds: [
          ...subscriprionUpdate?.componentiNucleoFamiliareIds,
          id,
        ],
      });
    }
  };

  const handleMinoriSave = () => {
    if (
      !subscriprionUpdate?.componentiNucleoFamiliareIds ||
      subscriprionUpdate.componentiNucleoFamiliareIds.length === 0
    ) {
      setMinoriError("Selezionare almeno un minore");
      return;
    }
    setMinoriError("");
    handleUpdate();
  };

  const bodyMinori = () => {
    return (
      <>
        <b>Selezionare il minore o i minori coinvolti:</b>
        <div className="d-flex flex-wrap pt-3 px-5 mx-5">
          {nucleoFamiliare?.map((c) => (
            <label key={c.id} className="mr-4 mb-2" style={{ minWidth: 220 }}>
              <input
                type="checkbox"
                checked={subscriprionUpdate?.componentiNucleoFamiliareIds?.includes(
                  c.id,
                )}
                onChange={() => handleCheck(c.id)}
              />{" "}
              {c.nome} {c.cognome} (
              {c.relazioneConAssistito ? c.relazioneConAssistito + ", " : ""}
              {c.dataNascita} (
              {c.dataNascita &&
                moment().diff(moment(c.dataNascita, "MM-DD-YYYY"), "years") +
                  1}{" "}
              anni), {c.codiceFiscale})
            </label>
          ))}
        </div>
        {minoriError && (
          <div className="alert alert-danger mt-2" role="alert">
            <b>Attenzione:</b> {minoriError}.
          </div>
        )}
      </>
    );
  };

  const bodyAdd = () => {
    return (
      <div className="row">
        <div className="col-lg-12">
          <div>
            <label htmlFor="descrizione">Descrizione:</label>
            <textarea
              id="descrizione"
              name="descrizione"
              value={fileSettings?.title}
              disabled={true}
              rows={1}
            />
          </div>

          <div className="row">
            <div className="col-12 d-flex justify-content-center mt-4">
              <UploadFile
                setErrorMessage={setErrorMessage}
                typeFile={[
                  "image/jpeg",
                  "image/jpg",
                  "image/png",
                  "application/pdf",
                ]}
                handleFile={setFileBase64}
                handleFileUploaded={setFileUpload}
                nameFile={setFilename}
              ></UploadFile>
              {errorMessage && (
                <div className="text-danger">
                  Carica un file con un formato supportato
                </div>
              )}
            </div>
          </div>
          {fileBase64 && (
            <object
              className="mt-5"
              width="100%"
              height="900"
              data={fileBase64}
              type="application/pdf"
            ></object>
          )}
          {error && (
            <div className="alert alert-danger mt-2" role="alert">
              <b>Attenzione:</b> {error}.
            </div>
          )}
        </div>
      </div>
    );
  };

  const bodyAddOre = () => {
    return (
      <>
        <div className="row">
          <div className="col-lg-2"></div>
          <div className="col-lg-8">
            <Input
              id="orePreviste"
              label="Ore previste"
              type="text"
              name="orePreviste"
              value={subscriprionUpdate?.orePreviste ?? ""}
              onChange={handleChange}
            />
          </div>
        </div>
      </>
    );
  };

  const [valore1, setValore1] = useState(null);
  const [valore2, setValore2] = useState(null);
  const [valore3, setValore3] = useState(null);

  useEffect(() => {
    if (subscriprionUpdate?.punteggioGravita && firstTime) {
      const match = subscriprionUpdate.punteggioGravita.match(
        /(\d+)\s*\+\s*(\d+)\s*\+\s*(\d+)/,
      );

      if (match) {
        const v1 = isNaN(Number(match[1])) ? 0 : Number(match[1]);
        const v2 = isNaN(Number(match[2])) ? 0 : Number(match[2]);
        const v3 = isNaN(Number(match[3])) ? 0 : Number(match[3]);

        setValore1(v1);
        setValore2(v2);
        setValore3(v3);

        // Totale numerico
        const punteggioTotale =
          Number(v1 || 0) + Number((v2 * v1) / 100) + Number((v3 * v1) / 100);

        setTotaleScore(punteggioTotale);
      }
      setFirstTime(false);
    }
  }, [subscriprionUpdate?.punteggioGravita]);

  useEffect(() => {
    if (valore1 && valore2 && valore3) {
      const totale =
        Number(valore1 || 0) +
        Number((valore2 * valore1) / 100) +
        Number((valore3 * valore1) / 100);

      setSubscriprionUpdate((prev) => ({
        ...prev,
        punteggioGravita: `${valore1} + ${valore2} + ${valore3} = ${totale}`,
      }));
    }
  }, [valore1, valore2, valore3]);

  const bodyPunteggio = () => {
    const punteggioTotale =
      Number(valore1 || 0) +
      Number((valore2 * valore1) / 100) +
      Number((valore3 * valore1) / 100);

    return (
      <>
        <div className="row mb-3">
          <div className="col-lg-12 ml-1">
            <label>
              <b>INDICE DI BARTHEL</b>
            </label>
            <select
              className="form-control border"
              value={valore1}
              onChange={(e) => setValore1(e.target.value)}
            >
              <option value="">Seleziona...</option>
              <option value={60}>
                Anziano/Disabile con TOTALE compromissione dell’autonomia •
                Range 32–18 • Punti 60
              </option>
              <option value={50}>
                Anziano/Disabile con GRAVE compromissione dell’autonomia • Range
                16–31 • Punti 50
              </option>
              <option value={40}>
                Anziano/Disabile con LIEVE compromissione dell’autonomia • Range
                0–15 • Punti 40
              </option>
            </select>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-lg-12 ml-1">
            <label>
              <b>SUPPORTO RETE SOCIALE</b>
            </label>
            <select
              className="form-control border"
              value={valore2}
              onChange={(e) => setValore2(e.target.value)}
            >
              <option value="">Seleziona...</option>
              <option value={40}>
                Anziano/Disabile NON SUFFICIENTEMENTE assistito • Range 165-240
                • Punti 40
              </option>
              <option value={20}>
                Anziano/Disabile PARZIALMENTE assistito • Range 85-160 • Punti
                20
              </option>
              <option value={0}>
                Anziano/Disabile BEN assistito • Range 0-80 • Punti 0
              </option>
            </select>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-lg-12 ml-1">
            <label>
              <b>CAPACITA' ECONOMICA</b>
            </label>
            <select
              className="form-control border"
              value={valore3}
              onChange={(e) => setValore3(e.target.value)}
            >
              <option value="">Seleziona...</option>
              <option value={16}>Range 0 - 2.000 • Punti 16</option>
              <option value={12}>Range 2.001 – 7.500 • Punti 12</option>
              <option value={8}>Range 7.501 – 10.000 • Punti 8</option>
              <option value={4}>Range 10.001 – 15.000 • Punti 4</option>
              <option value={2}>Range 15.001 – 20.000 • Punti 2</option>
              <option value={0}>Range 20.001 - 25.000 • Punti 0</option>
            </select>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-lg-8 offset-lg-2">
            <h4>
              Punteggio totale: <b>{punteggioTotale}</b>
            </h4>
          </div>
        </div>
      </>
    );
  };

  const sendReceiptApi = async () => {
    Repo.postSendSubscriptionFileOperator(apiToken, data)
      .then((response) => {
        if (response.status === 200) {
          setIsAlertVisible(true);
          toggleModal(false);
          getSubscriptioFiles();
          clearFile();
        }
      })
      .catch((error) => {
        toggleModal(false);
        console.error(error);
        if (error.response) {
          console.error(error.response); // Log della risposta in caso di errore
        }
      });
  };

  const clearFile = () => {
    setValue("");
    setUploadFile("");
    setFilename("");
    setErrorMessageImport("");
    setValidation(false);
    setValidationFile(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSubscriprionUpdate((subscriprionUpdate) => ({
      ...subscriprionUpdate,
      [name]: value,
    }));
  };
  const bodyModify = () => {
    return (
      <>
        {!fileB64 ? (
          <>
            <label htmlFor="state">Seleziona l'esito della richiesta*</label>
            <select
              id="state"
              name="state"
              className="custom-textarea"
              value={subscriprionUpdate?.state}
              onChange={handleChange}
            >
              <option value="">Seleziona uno stato</option>
              <option value="VALIDATED">Validata</option>
              <option value="REFUSED">Rifiutata</option>
              <option value="SUSPENDED">Sospesa</option>
            </select>
            {subscriprionUpdate.state == "VALIDATED" &&
              subscriprionUpdate?.announcement?.service?.tipoServizio != 0 && (
                <>
                  <Row form className="mt-4 mb-4">
                    <Col md={3}></Col>
                    <Col md={6}>
                      <Input
                        id="nProtocolloUscita"
                        label="Protocollo in uscita"
                        type="text"
                        name="nProtocolloUscita"
                        step="1"
                        value={subscriprionUpdate?.nProtocolloUscita}
                        onChange={handleChange}
                      />
                    </Col>
                  </Row>
                  {(subscriprionUpdate?.announcement?.service?.tipoServizio ===
                    3 ||
                    subscriprionUpdate?.announcement?.service?.tipoServizio ===
                      5) && (
                    <EditorJs
                      editorTemp={dettaglio}
                      setEditorTemp={setDettaglio}
                    />
                  )}
                  {subscriprionUpdate?.announcement?.service?.tipoServizio ===
                    1 && (
                    <>
                      <Row form className="mt-4 mb-4">
                        <Col md={3}></Col>
                        <Col md={6}>
                          <Input
                            id="orePreviste"
                            label="Numero di ore concesse*"
                            type="number"
                            name="orePreviste"
                            step="1"
                            value={subscriprionUpdate?.orePreviste}
                            onChange={handleChange}
                          />
                        </Col>
                      </Row>
                      <Row form className="mb-2 mt-2">
                        <Col md={1}></Col>
                        <Col md={4}>
                          <Input
                            label="Data di avvio*"
                            type="date"
                            max={"9999-12-31"}
                            id="dataInizio"
                            name="dataInizio"
                            value={
                              subscriprionUpdate?.dataInizio
                                ? moment(subscriprionUpdate.dataInizio, [
                                    "DD/MM/YYYY",
                                    "YYYY-MM-DD",
                                  ]).format("YYYY-MM-DD")
                                : " "
                            }
                            onChange={handleChange}
                          />
                        </Col>
                        <Col md={2}></Col>
                        <Col md={4}>
                          <Input
                            label="Data di termine*"
                            type="date"
                            max={"9999-12-31"}
                            id="dataFine"
                            name="dataFine"
                            value={
                              subscriprionUpdate?.dataFine
                                ? moment(subscriprionUpdate.dataFine, [
                                    "DD/MM/YYYY",
                                    "YYYY-MM-DD",
                                  ]).format("YYYY-MM-DD")
                                : " "
                            }
                            min={
                              subscriprionUpdate?.dataInizio
                                ? moment(subscriprionUpdate.dataInizio, [
                                    "DD/MM/YYYY",
                                    "YYYY-MM-DD",
                                  ]).format("YYYY-MM-DD")
                                : undefined
                            }
                            onChange={handleChange}
                          />
                        </Col>
                      </Row>
                    </>
                  )}
                </>
              )}
            <div className="form-group mt-5 mb-4">
              <label
                htmlFor="descrizione"
                className={subscriprionUpdate?.descrizione ? "active" : ""}
              >
                Descrizione*
              </label>
              <textarea
                id="descrizione"
                name="descrizione"
                value={subscriprionUpdate?.descrizione || ""}
                onChange={handleChange}
                className="custom-textarea"
                rows={3}
              />
            </div>
            <div className="row">
              <div className="col-lg-12">
                {error && (
                  <div className="alert alert-danger mt-2" role="alert">
                    <b>Attenzione:</b> {error}.
                  </div>
                )}
                <div className="d-flex justify-content-end">
                  <button
                    className="btn btn-primary btn-salva"
                    type="button"
                    onClick={() => handleUpdate()}
                  >
                    Ufficializza{" "}
                    {subscriprionUpdate.state == "VALIDATED" &&
                      (subscriprionUpdate?.announcement?.service
                        ?.tipoServizio === 3 ||
                        subscriprionUpdate?.announcement?.service
                          ?.tipoServizio === 5) &&
                      " e crea pdf"}
                  </button>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <object
              className="mt-5"
              width="100%"
              height="900"
              data={
                fileB64 ? `data:application/pdf;base64,${fileB64}` : undefined
              }
              type="application/pdf"
            ></object>
          </>
        )}{" "}
      </>
    );
  };

  //coupon
  const bodyGenerateCoupons = () => {
    return (
      <>
        <div className="row">
          <div className="col-12">
            <label htmlFor="toggleTitle">Nome buono servizio:</label>
            <input
              type="text"
              id="toggleTitle"
              name="toggleTitle"
              value={userSubscriptions?.announcement.name}
            />
          </div>

          <div className="col-6">
            <label htmlFor="toggleMaxMonthlyUsage">
              Numero massimo di utilizzi:
            </label>
            <input
              type="number"
              id="toggleMaxMonthlyUsage"
              name="toggleMaxMonthlyUsage"
            />
          </div>

          <div className="col-6">
            <label htmlFor="toggleValore">Valore:</label>
            <input type="number" id="toggleValore" name="toggleValore" />
          </div>
        </div>

        {errorMessageImport && (
          <div className="text-danger">Buoni generati correttamente</div>
        )}
      </>
    );
  };

  const sendGenerateCoupons = () => {
    let obj = {
      announcementId: userSubscriptions?.announcement.id,
      title: toggleTitle.value,
      valore: toggleValore.value,
      maxMonthlyUsage: toggleMaxMonthlyUsage.value,
      userId: userSubscriptions?.user?.id,
      // executiveId: previouslySelectedOption.value,
    };

    setLoading(true);
    Repo.generateCoupons(apiToken, obj)
      .then((response) => {
        if (response.status == 200) {
          toggleModalCoupon(false);
          setLoading(false);
          alert("Buoni creati correttamente!");
        }
      })
      .catch((error) => {
        setLoading(false);
        setErrorMessageImport(error);
      });
  };

  useEffect(() => {
    // qui ritorna tutti i coupon attivi per quell'utente ma non sono filtrati
    if (userSubscriptions?.user.fiscalCode) {
      // prendiamo i pagamenti sulla base del cod. fiscale e id iscrizione
      getPayments(userSubscriptions.id, userSubscriptions.user.fiscalCode);

      if (userSubscriptions?.announcement.hasCoupon) {
        setLoading(true); // Imposta loading su true prima della chiamata API
        Repo.GetCouponsByCF(apiToken, userSubscriptions.user.fiscalCode)
          .then((response) => {
            setCouponsList(response.data);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            setLoading(false); // Imposta loading su false alla fine, indipendentemente dall'esito
          });
      }

      if (userSubscriptions?.announcement.hasMoney) {
        /// questione dei rimborsi per iscrizione
        //     /api /Operatore /lista-allegati-iscrizione /{subscriptionId}
        // Imposta loading su true prima della chiamata API

        getSubscriptioFiles();
      }
    }
  }, [
    apiToken,
    userSubscriptions?.announcement.hasCoupon,
    userSubscriptions?.announcement.hasMoney,
    userSubscriptions?.user.fiscalCode,
  ]);

  const getSubscriptioFiles = () => {
    setLoading(true);
    Repo.getSubscriptionFileOperator(apiToken, subscriprionParamId)
      .then((response) => {
        setRefundTemp(response.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false); // Imposta loading su false alla fine, indipendentemente dall'esito
      });
  };

  const getPayments = (id, fiscalCode) => {
    Repo.getListPaymentOperator(apiToken, id, fiscalCode)
      .then((response) => {
        if (response.status == 200) {
          setPaymentsTemp(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (userSubscriptions?.user?.id)
      Repo.haveUserIsee(apiToken, userSubscriptions?.user?.id)
        .then((response) => {
          setHaveIsee(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
  }, [userSubscriptions?.user?.id]);

  return (
    <>
      <div className="clearfix col-lg-12 py-lg-2">
        <h1>
          Iscrizione{" "}
          {userSubscriptions && userSubscriptions.user.firstName
            ? " " +
              userSubscriptions.user.lastName +
              " " +
              userSubscriptions.user.firstName
            : ""}
        </h1>
        {userSubscriptions && (
          <p>
            Scheda di riepilogo dell'iscrizione all' intervento - (
            {userSubscriptions.announcement.name})
          </p>
        )}
      </div>
      {userSubscriptions?.descrizioneIstanze && !editDescrizioneIstanze && (
        <h5>
          <div className="row">
            <div className="col-2">Dettagli istanza: </div>
            <div className="col-8">
              <strong style={{ whiteSpace: "pre-line" }}>
                <span
                  dangerouslySetInnerHTML={{
                    __html: normalizeMultilineText(
                      userSubscriptions?.descrizioneIstanze,
                    ),
                  }}
                ></span>
              </strong>
            </div>
            {console.log(
              "userSubscriptions.descrizioneIstanze: ",
              userSubscriptions.descrizioneIstanze,
            )}

            <div className="col-2 text-right">
              {props.isOperator && (
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm"
                  onClick={() => {
                    setDescrizioneIstanzeEdit(
                      userSubscriptions.descrizioneIstanze,
                    );
                    setEditDescrizioneIstanze(true);
                  }}
                  title="Modifica dettagli istanza"
                >
                  <svg className="icon icon-primary">
                    <use href={`${iconSprite}#it-pencil`} />
                  </svg>
                </button>
              )}
            </div>
          </div>
        </h5>
      )}
      {editDescrizioneIstanze && (
        <div className="row mb-3">
          <div className="col-12">
            <EditorJs
              editorTemp={descrizioneIstanzeEdit}
              setEditorTemp={setDescrizioneIstanzeEdit}
            />
            <div className="text-right mt-2">
              <button
                type="button"
                className="btn btn-outline-secondary m-2"
                onClick={() => setEditDescrizioneIstanze(false)}
              >
                Annulla
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  setLoading(true);
                  Repo.postSubscribeUserFromOperator(
                    apiToken,
                    JSON.stringify({
                      id: subscriprionParamId,
                      announcementId: userSubscriptions.announcementId,
                      descrizioneIstanze: descrizioneIstanzeEdit,
                    }),
                  )
                    .then(() => window.location.reload())
                    .catch((error) => {
                      Repo.handleApiError(error, setError);
                      setLoading(false);
                    });
                }}
              >
                Salva
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="container">
        {emailSend && (
          <div
            className={`alert ${
              emailSend.startsWith("ERRORE:") ? "alert-danger" : "alert-success"
            } mt-2`}
            role="alert"
          >
            <b>
              {emailSend.startsWith("ERRORE:") ? "Attenzione" : "Successo"}:
            </b>{" "}
            {emailSend}.
          </div>
        )}
        {userSubscriptions?.state === "REFUSED" && (
          <div className="alert alert-danger mt-2" role="alert">
            <div className="row">
              <b className="mr-1">Motivazione del rifiuto:</b>{" "}
              {userSubscriptions?.descrizione}
              {props.isOperator && (
                <div className="col text-right">
                  <button
                    type="button"
                    className="btn btn-outline-primary text-success  p-2"
                    onClick={() => {
                      setshowModalModify(true);
                    }}
                    title="Modifica iscrizione"
                  >
                    <svg className="icon icon-primary">
                      <use href={`${iconSprite}#it-pencil`} />
                    </svg>
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
        {userSubscriptions?.state === "SUSPENDED" && (
          <div className="alert alert-danger mt-2" role="alert">
            <div className="row">
              <b className="mr-1">Motivazione della sospensione: </b>
              {userSubscriptions?.descrizione}
              {props.isOperator && (
                <div className="col text-right">
                  <button
                    type="button"
                    className="btn btn-outline-primary text-success  p-2"
                    onClick={() => {
                      setshowModalModify(true);
                    }}
                    title="Modifica iscrizione"
                  >
                    <svg className="icon icon-primary">
                      <use href={`${iconSprite}#it-pencil`} />
                    </svg>
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
        {userSubscriptions?.announcement?.service?.tipoServizio === 0 &&
          (userSubscriptions?.state === "ADDED" ||
            userSubscriptions?.state === "LOADED") && (
            <SubscriptionDetailGenerico
              userSubscriptions={userSubscriptions}
              setshowModalModify={setshowModalModify}
              isOperator={props.isOperator}
            />
          )}
        {userSubscriptions?.announcement?.service?.tipoServizio === 1 && (
          <SubscriptionDetailSAD
            userSubscriptions={userSubscriptions}
            toggleModalShowFile={toggleModalShowFile}
            toggleModalAdd={toggleModalAdd}
            setFile={setFile}
            setFileSettings={setFileSettings}
            setshowModalModify={setshowModalModify}
            isOperator={props.isOperator}
            toggleModalPunteggio={toggleModalPunteggio}
            totaleScore={totaleScore}
            toggleModalAddHours={toggleModalAddHours}
            setShowModalOtherServices={setShowModalOtherServices}
          ></SubscriptionDetailSAD>
        )}
        {userSubscriptions?.announcement?.service?.tipoServizio === 2 && (
          <SubscriptionDetailADI
            userSubscriptions={userSubscriptions}
            toggleModalShowFile={toggleModalShowFile}
            toggleModalAdd={toggleModalAdd}
            toggleModalAddHours={toggleModalAddHours}
            setFile={setFile}
            setFileSettings={setFileSettings}
            setshowModalModify={setshowModalModify}
            isOperator={props.isOperator}
            isDelegate={props.isDelegate}
            isExecutive={props.isExecutive}
            haveIsee={haveIsee}
            setShowModalOtherServices={setShowModalOtherServices}
          ></SubscriptionDetailADI>
        )}
        {(userSubscriptions?.announcement?.service?.tipoServizio === 3 ||
          userSubscriptions?.announcement?.service?.tipoServizio === 4) && (
          <SubscriptionDetailRelation
            userSubscriptions={userSubscriptions}
            toggleModalShowFile={toggleModalShowFile}
            toggleModalAdd={toggleModalAdd}
            toggleModalAddHours={toggleModalAddHours}
            setFile={setFile}
            setFileSettings={setFileSettings}
            setshowModalModify={setshowModalModify}
            isOperator={props.isOperator}
            isDelegate={props.isDelegate}
            isExecutive={props.isExecutive}
          ></SubscriptionDetailRelation>
        )}
        {userSubscriptions?.announcement?.service?.tipoServizio === 5 && (
          <SubscriptionDetailCentroFamiglia
            userSubscriptions={userSubscriptions}
            toggleModalShowFile={toggleModalShowFile}
            toggleModalAdd={toggleModalAdd}
            toggleModalAddHours={toggleModalAddHours}
            setFile={setFile}
            setFileSettings={setFileSettings}
            setshowModalModify={setshowModalModify}
            isOperator={props.isOperator}
            isDelegate={props.isDelegate}
            isExecutive={props.isExecutive}
          ></SubscriptionDetailCentroFamiglia>
        )}
        {userSubscriptions?.announcement?.service?.tipoServizio === 6 && (
          <SubscriptionDetailFamiglieAffidatarie
            userSubscriptions={userSubscriptions}
            toggleModalShowFile={toggleModalShowFile}
            toggleModalAdd={toggleModalAdd}
            toggleModalMinori={toggleModalMinori}
            toggleModalAddHours={toggleModalAddHours}
            setFile={setFile}
            setFileSettings={setFileSettings}
            setshowModalModify={setshowModalModify}
            isOperator={props.isOperator}
            isDelegate={props.isDelegate}
            isExecutive={props.isExecutive}
          ></SubscriptionDetailFamiglieAffidatarie>
        )}
        <div className="row">
          <div className="col">
            {subscriprionParamId && (
              <AllegatiComponent
                entityId={subscriprionParamId}
                tipoEntity="Subscription"
                isOperator={props.isOperator}
                targetEntityId={userSubscriptions?.user?.id}
                targetEntityType="User"
              />
            )}
          </div>
        </div>
        <div className="row">
          <div className="col">
            {userSubscriptions?.announcement.hasPayment ? (
              <ListPaymemtsUsers
                payments={payments}
                paymentsTemp={paymentsTemp}
                setPayments={setPayments}
                fiscalCode={true}
                userId={userSubscriptions?.user?.id}
              />
            ) : (
              <></>
            )}
          </div>
        </div>
        {/** HA PAGAMENTI  FINE*/}
        {/** HA PRESENZE  */}
        <div className="row">
          <div className="col">
            {userSubscriptions?.announcement.hasPresenze ? <></> : <></>}
          </div>
        </div>
        {/** HA PRESENZE  FINE*/}
        {/** HA RIMBORSI  */}
        <div className="row">
          <div className="col">
            {userSubscriptions?.announcement.hasMoney ? (
              <>
                <div className="card-wrapper card-space">
                  <div className="card card-bg card-big roundedCustom">
                    <div className="card-body">
                      <div className="row">
                        <div className="col">
                          <div className="row">
                            <div className="col-lg-8">
                              <UploadFile
                                setErrorMessage={setErrorMessageImport}
                                typeFile={[
                                  "image/jpeg",
                                  "image/jpg",
                                  "image/png",
                                  "application/pdf",
                                ]}
                                handleFile={setUploadFile}
                                nameFile={setFilename}
                              ></UploadFile>

                              {errorMessageImport && (
                                <div className="text-danger">
                                  Carica un file con un formato supportato
                                </div>
                              )}
                              {validation && !validationFile ? (
                                <div className="text-danger">
                                  Non è stato caricato nessun documento
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>

                            <div className="col-lg-4 pl-5">
                              <label className="active" htmlFor="input-group-3">
                                Note*
                              </label>
                              <div className="row mb-4">
                                <Input
                                  id="description"
                                  value={description}
                                  name="Note"
                                  disabled={isDisabled}
                                  onChange={(e) =>
                                    setDescription(e.target.value)
                                  }
                                  {...(validation &&
                                    (description == "" ||
                                      description == " " ||
                                      !description) && {
                                      infoText:
                                        "Il campo non può essere vuoto!",
                                      className: "text-danger error_div",
                                    })}
                                />
                              </div>

                              <label className="active" htmlFor="input-group-3">
                                Importo
                              </label>
                              <div className="row mb-4">
                                <Input
                                  id="value"
                                  value={value}
                                  name="Importo"
                                  disabled={isDisabled}
                                  onChange={(e) =>
                                    setValue(
                                      e.target.value.match(number)
                                        ? e.target.value
                                        : value,
                                    )
                                  }
                                  {...(validation &&
                                    (value == "" || value == " " || !value) && {
                                      infoText:
                                        "Il campo non può essere vuoto!",
                                      className: "text-danger error_div",
                                    })}
                                />
                              </div>
                              <div className="row my-2">
                                <div className="col-lg-12 text-right">
                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    disabled={isDisabled}
                                    onClick={() => sendReceipt()}
                                    title="Conferma"
                                  >
                                    Invia
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row my-2">
                    <div className="col-lg-9">
                      <h5>
                        Rimborsi{" "}
                        <i>
                          {userSubscriptions && userSubscriptions.user.firstName
                            ? " " +
                              userSubscriptions.user.lastName +
                              " " +
                              userSubscriptions.user.firstName
                            : ""}
                        </i>
                      </h5>
                    </div>
                  </div>

                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col">Valore rimborso richiesto</th>
                        <th scope="col">Note</th>
                        <th scope="col">Data inserimento</th>
                        <th scope="col">Stato</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {refundTemp &&
                        refundTemp.length > 0 &&
                        refundTemp.map((y, index) => (
                          <tr key={index}>
                            <td>
                              {y.valore
                                ? parseFloat(y.valore).toLocaleString("it-IT", {
                                    style: "currency",
                                    currency: "EUR",
                                  })
                                : ""}
                            </td>
                            <td>{y.description}</td>
                            <td>{y.dataInsert}</td>
                            <td>
                              {y.state == "1" ? (
                                <>
                                  <b className="text-success">
                                    <svg className="icon icon-success">
                                      <use
                                        href={`${iconSprite}#it-check-circle`}
                                      />
                                    </svg>{" "}
                                    ACCETTATO
                                  </b>
                                </>
                              ) : y.state == "0" ? (
                                <b className="">
                                  <svg className="icon">
                                    <use
                                      href={`${iconSprite}#it-close-circle`}
                                    />
                                  </svg>
                                  DA VERIFICARE
                                </b>
                              ) : y.state == "2" ? (
                                <b className="text-danger">
                                  <svg className="icon icon-danger">
                                    <use
                                      href={`${iconSprite}#it-close-circle`}
                                    />
                                  </svg>{" "}
                                  RIFIUTATO
                                </b>
                              ) : (
                                <b className="text-danger">
                                  <svg className="icon icon-danger">
                                    <use
                                      href={`${iconSprite}#it-close-circle`}
                                    />
                                  </svg>{" "}
                                  {y.state}
                                </b>
                              )}
                            </td>
                            <td style={{ textAlign: "right" }}>
                              <>
                                <Link
                                  to={
                                    "/visualizza_rimborso?idRefund=" +
                                    y.storageFileId +
                                    "&id=" +
                                    y.id
                                  }
                                >
                                  <button
                                    className="btn btn-outline-primary p-2"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Dettaglio"
                                  >
                                    <svg className="icon icon-primary">
                                      <use href={`${iconSprite}#it-search`} />
                                    </svg>
                                  </button>
                                </Link>
                              </>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  {refund && (
                    <Pagination
                      items={refundTemp}
                      setCurrentItems={setRefund}
                      itemsPerPage={5}
                    ></Pagination>
                  )}
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
        {/** Fine Rimborsi */}
      </div>
      <ModalComponent
        toggleModal={toggleModalCoupon}
        isOpen={isOpenCoupon}
        header="Buoni servizio"
        body={bodyGenerateCoupons()}
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendGenerateCoupons()}
      ></ModalComponent>
      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Caricamento Ricevuta"
        body="Confermi di voler caricare la ricevuta?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendReceiptApi()}
      ></ModalComponent>

      <ModalComponent
        toggleModal={() => toggleModalShowFile(!showFileToggle)}
        isOpen={showFileToggle}
        header={"File"}
        body={bodyFile()}
        buttonDeny="Chiudi"
      ></ModalComponent>

      <ModalComponent
        toggleModal={setshowModalModify}
        isOpen={showModalModify}
        header="Valutazione atto"
        body={bodyModify()}
        buttonDeny="Chiudi"
        onClose={handleCloseModalModify}
      />

      <ModalComponent
        toggleModal={toggleModalAdd}
        isOpen={showModalAdd}
        header={"Carica " + fileSettings.title}
        body={bodyAdd()}
        buttonDeny="Chiudi"
        function={() => handleSave()}
        buttonConfirm="Salva"
        onClose={handleCloseModalModify}
      />
      <ModalComponent
        toggleModal={toggleModalAddHours}
        isOpen={showModalAddHours}
        header="Inserisci ore stabilite dell'equipe medica"
        body={bodyAddOre()}
        buttonDeny="Chiudi"
        function={() => handleUpdateOre()}
        buttonConfirm="Salva"
      />
      <ModalComponent
        toggleModal={toggleModalPunteggio}
        isOpen={showModalPunteggio}
        header="Stabilisci il punteggio di gravità"
        body={bodyPunteggio()}
        buttonDeny="Chiudi"
        function={() => handleUpdateRankingScore()}
        buttonConfirm="Salva"
      />
      <ModalComponent
        toggleModal={setShowModalOtherServices}
        isOpen={showModalOtherServices}
        header="Crea PDF Relazione"
        body={bodyOtherService()}
        buttonDeny="Chiudi"
        buttonConfirm="Conferma"
        function={() => handleUpdate()}
      />
      <ModalComponent
        toggleModal={toggleModalMinori}
        isOpen={showModalMinori}
        header="Minori convolti"
        body={bodyMinori()}
        buttonDeny="Chiudi"
        function={handleMinoriSave}
        buttonConfirm="Salva"
      />
      {loading && <Loader />}
    </>
  );
}

export default SubscriptionDetail;
